import { createContext as A, useContext as f, useReducer as R, useEffect as O, useCallback as v } from "react";
import { jsx as m, jsxs as N } from "react/jsx-runtime";
import { createEventEmitter as x } from "@made-people/grease-event-emitter";
import { useRequester as i } from "@made-people/react-use-requester";
import { z as y } from "zod";
import { isE164PhoneNumberString as b } from "@made-people/types-e164-phone-number-string";
const T = x();
var u = /* @__PURE__ */ ((t) => (t.SetAccountData = "SET_ACCOUNT_DATA", t.ClearAccountData = "CLEAR_ACCOUNT_DATA", t.SetOrders = "SET_ORDERS", t))(u || {});
const U = (t, e) => {
  switch (e.type) {
    case "SET_ACCOUNT_DATA":
      return { ...t, customer: e.payload.customer };
    case "SET_ORDERS":
      return { ...t, orders: e.payload.orders };
    case "CLEAR_ACCOUNT_DATA":
      return {};
    default:
      return t;
  }
}, D = A(void 0), h = () => {
  const t = f(D);
  if (!t)
    throw new Error(
      "useAccountEventEmitter must be used inside a <AccountEventEmitterContext />"
    );
  return t;
}, _ = A(void 0), g = A(
  void 0
), P = A(void 0), F = (t) => {
  const [e, r] = R(U, {}), o = {
    eventEmitter: t.accountEventEmitter ?? T
  };
  return /* @__PURE__ */ m(D.Provider, { value: o, children: /* @__PURE__ */ m(P.Provider, { value: t.accountClientDriver, children: /* @__PURE__ */ m(g.Provider, { value: e, children: /* @__PURE__ */ N(_.Provider, { value: r, children: [
    t.disableFetchOnMount || /* @__PURE__ */ m(I, { initializeOnMount: t.initializeOnMount }),
    t.children
  ] }) }) }) });
};
F.displayName = "AccountProvider";
const a = () => {
  const t = f(P);
  if (!t)
    throw new Error(
      "useAccountClient must be used inside a <AccountProvider />"
    );
  return t;
}, d = () => {
  const t = f(_);
  if (!t)
    throw new Error(
      "useAccountDispatch must be used inside an <AccountProvider />"
    );
  return t;
}, L = () => {
  const t = a(), e = d();
  return i(async () => {
    const r = await t.fetchCustomer();
    if (!r || !r.customer) {
      e({
        type: u.SetAccountData,
        payload: {
          customer: null
        }
      });
      return;
    }
    e({
      type: u.SetAccountData,
      payload: r
    });
  });
}, I = ({
  initializeOnMount: t = !0
}) => {
  const e = L();
  return O(() => {
    t && e.execute();
  }, []), null;
}, W = {
  login: "login",
  logout: "logout",
  register: "register",
  fetchOrders: "fetchOrders",
  resetPassword: "resetPassword",
  sendResetPasswordEmail: "sendResetPasswordEmail",
  fetchCustomer: "fetchCustomer",
  updateCustomer: "updateCustomer"
}, S = A(void 0), G = (t) => /* @__PURE__ */ m(S.Provider, { value: t, children: t.children }), E = () => {
  const t = f(S);
  return t || { additionalData: void 0 };
}, C = 8, p = (t) => y.string().min(C).safeParse(t).success, w = (t) => y.string().email().safeParse(t).success, M = (t) => b(t), k = (t) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(t))
    return !1;
  const e = t.split("-").map(Number), r = e[0], o = e[1], c = e[2];
  if (r === void 0 || o === void 0 || c === void 0 || r < 1900)
    return !1;
  const s = new Date(r, o - 1, c);
  if (s.getFullYear() !== r || s.getMonth() + 1 !== o || s.getDate() !== c)
    return !1;
  const n = /* @__PURE__ */ new Date();
  return n.setHours(0, 0, 0, 0), !(s >= n);
}, K = () => {
  const t = a(), e = d();
  return i(async () => {
    const r = await t.fetchOrders();
    if (!r)
      throw new Error("Account_Fetch_Orders_Error");
    e({
      type: u.SetOrders,
      payload: r
    });
  });
}, Y = () => {
  const t = a(), { eventEmitter: e } = h(), { additionalData: r } = E(), o = d(), c = v(
    async (s) => {
      if (s.email === "" && s.password === "")
        return {
          success: !1,
          error: "Account_MissingFields"
        };
      if (!w(s.email))
        return {
          success: !1,
          error: "Account_InvalidEmail"
        };
      try {
        const n = await t.login(s);
        return n.customer ? (e.emit("loginSuccess", {
          additionalData: r,
          method: s.method ?? "email"
        }), o({
          type: u.SetAccountData,
          payload: {
            customer: n.customer
          }
        }), {
          success: !0
        }) : (e.emit("loginFailure", {
          additionalData: r,
          method: s.method ?? "email"
        }), {
          success: !1,
          error: "Account_InvalidCredentials"
        });
      } catch (n) {
        return console.error(n), {
          success: !1,
          error: "Account_UnknownError"
        };
      }
    },
    [t, o, e, r]
  );
  return i(c);
}, $ = () => {
  const t = a(), e = d();
  return i(async () => {
    await t.logout(), e({
      type: u.ClearAccountData
    });
  });
}, J = () => {
  const t = a(), e = d(), { eventEmitter: r } = h(), { additionalData: o } = E();
  return i(
    async (c) => {
      const s = c.email.toLowerCase();
      if (!s || !c.password)
        return {
          success: !1,
          error: "Account_MissingFields"
        };
      if (c.phoneNumber && !M(c.phoneNumber))
        return {
          success: !1,
          error: "Account_InvalidPhoneNumber"
        };
      if (c.birthdate && !k(c.birthdate))
        return {
          success: !1,
          error: "Account_InvalidBirthdate"
        };
      if (!w(s))
        return {
          success: !1,
          error: "Account_InvalidEmail"
        };
      if (!p(c.password))
        return {
          success: !1,
          error: "Account_PasswordNotSecure",
          minLength: C
        };
      let n;
      try {
        const l = await t.register({
          ...c,
          email: s
        });
        if (l.success)
          n = l.data;
        else if (l.error === "Account_EmailAlreadyExists")
          return {
            success: !1,
            error: "Account_EmailAlreadyExists"
          };
      } catch (l) {
        console.error("Error when trying to register user", l);
      }
      return n ? (e({
        type: u.SetAccountData,
        payload: n
      }), r.emit("registerSuccess", {
        additionalData: o,
        method: c.method ?? "email"
      }), {
        success: !0
      }) : (r.emit("registerFailure", {
        additionalData: o,
        method: c.method ?? "email"
      }), {
        success: !1,
        error: "Account_UnknownError"
      });
    }
  );
}, Q = () => {
  const t = a(), { eventEmitter: e } = h(), { additionalData: r } = E(), o = d(), c = v(
    async (s) => {
      if (!p(s.newPassword))
        return {
          success: !1,
          error: "Account_PasswordNotSecure",
          minLength: C
        };
      try {
        return await t.resetPassword(s), {
          success: !0
        };
      } catch (n) {
        return console.error(n), {
          success: !1,
          error: "Account_UnknownError"
        };
      }
    },
    [t, o, e, r]
  );
  return i(c);
}, X = () => {
  const t = a(), { eventEmitter: e } = h(), { additionalData: r } = E(), o = d(), c = v(
    async (s) => {
      if (!w(s.email))
        return {
          success: !1,
          error: "Account_InvalidEmail"
        };
      try {
        return await t.sendResetPasswordEmail(s), {
          success: !0
        };
      } catch (n) {
        return console.error(n), {
          success: !1,
          error: "Account_UnknownError"
        };
      }
    },
    [t, o, e, r]
  );
  return i(c);
}, Z = () => {
  const t = f(g);
  if (!t)
    throw new Error(
      "useAccountState must be used inside an <AccountProvider />"
    );
  return t;
}, tt = () => {
  const t = a(), { eventEmitter: e } = h(), { additionalData: r } = E(), o = d(), c = v(
    async (s) => {
      let n;
      try {
        n = await t.updateCustomer(s);
      } catch (l) {
        console.error("Error updating customer", l);
      }
      return n ? (o({
        type: u.SetAccountData,
        payload: n
      }), {
        success: !0
      }) : {
        success: !1,
        error: "UNKNOWN_ERROR"
      };
    },
    [t, o, e, r]
  );
  return i(c);
};
export {
  u as AccountActionTypes,
  G as AccountEventAdditionalDataProvider,
  D as AccountEventEmitterContext,
  I as AccountInitialize,
  F as AccountProvider,
  C as PASSWORD_MIN_LENGTH,
  P as accountClientContext,
  W as accountClientMethods,
  _ as accountDispatchContext,
  T as accountEventEmitter,
  U as accountReducer,
  g as accountStateContext,
  p as isSecurePassword,
  k as isValidBirthdate,
  w as isValidEmail,
  M as isValidPhoneNumber,
  a as useAccountClient,
  d as useAccountDispatch,
  E as useAccountEventAdditionalData,
  h as useAccountEventEmitter,
  L as useAccountFetchCustomer,
  K as useAccountFetchOrders,
  Y as useAccountLogin,
  $ as useAccountLogout,
  J as useAccountRegister,
  Q as useAccountResetPassword,
  X as useAccountSendResetPasswordEmail,
  Z as useAccountState,
  tt as useAccountUpdateCustomer
};
